import Ads from './ads/index';
import Album from './media/album';
import Auth from './auth/index';
import Forecasts from './forecasts/index';
import NewsBlock from './news/block';
import NewsList from './news/index';
import NewsSidebar from './news/sidebar';
import NewsView from './news/view';
import MediaList from './media/index';
import MatchesList from './matches/index';
import MatchCenter from './matches/center';
import Header from './header/index';
import Sidebar from './sidebar/index';
import Transfers from './transfers/index';

window.controllers = {Ads, Album, Auth, Forecasts, NewsBlock, NewsList, NewsSidebar, NewsView, MediaList, MatchesList, MatchCenter, Header, Transfers};
export default {};